import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowLeft } from "lucide-react";
import { Button } from "@/components/ui/button";
import { SEOHead } from "@/components/seo/SEOHead";

export default function Privacidade() {
  return (
    <>
      <SEOHead title="Política de Privacidade | Publee" description="Política de privacidade da plataforma Publee." />
      <div className="min-h-screen bg-background">
        <div className="container mx-auto px-4 py-12 max-w-3xl">
          <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.5 }}>
            <Button asChild variant="ghost" size="sm" className="mb-8">
              <Link to="/"><ArrowLeft className="w-4 h-4 mr-2" />Voltar</Link>
            </Button>

            <h1 className="text-4xl font-bold mb-8">Política de Privacidade</h1>
            <div className="prose prose-invert max-w-none space-y-6 text-muted-foreground">
              <p><strong className="text-foreground">Última atualização:</strong> Fevereiro de 2026</p>

              <h2 className="text-xl font-semibold text-foreground">1. Dados Coletados</h2>
              <p>Coletamos: nome, email, dados de uso da plataforma e informações de pagamento. Não armazenamos dados de cartão diretamente.</p>

              <h2 className="text-xl font-semibold text-foreground">2. Uso dos Dados</h2>
              <p>Seus dados são usados para: fornecer o serviço, processar pagamentos, enviar comunicações sobre sua conta e melhorar a plataforma.</p>

              <h2 className="text-xl font-semibold text-foreground">3. Compartilhamento</h2>
              <p>Não vendemos seus dados. Compartilhamos apenas com processadores de pagamento e provedores de infraestrutura necessários para operar o serviço.</p>

              <h2 className="text-xl font-semibold text-foreground">4. Segurança</h2>
              <p>Utilizamos criptografia, autenticação segura e práticas de segurança da indústria para proteger seus dados.</p>

              <h2 className="text-xl font-semibold text-foreground">5. Seus Direitos</h2>
              <p>Você pode solicitar acesso, correção ou exclusão dos seus dados a qualquer momento entrando em contato conosco.</p>

              <h2 className="text-xl font-semibold text-foreground">6. Cookies</h2>
              <p>Usamos cookies essenciais para autenticação e funcionamento da plataforma. Cookies analíticos são usados para melhorar a experiência.</p>

              <h2 className="text-xl font-semibold text-foreground">7. Contato</h2>
              <p>Para questões de privacidade: <a href="mailto:suporte@publee.art" className="text-primary hover:underline">suporte@publee.art</a></p>
            </div>
          </motion.div>
        </div>
      </div>
    </>
  );
}
